import React from 'react';
import Select from 'react-select';
import {Box, CircularProgress} from '@chakra-ui/react';
import {DocumentIcon} from "@heroicons/react/outline";

const CustomOption = ({innerProps, data, isFocused}) => (
  <Box
    {...innerProps}
    mx={2}
    my={2}
    p={2}
    display={"flex"}
    borderRadius="md"
    alignItems={"center"}
    borderWidth="1px"
    borderColor={isFocused ? 'blue.300' : 'gray.300'}
    backgroundColor={isFocused ? 'blue.50' : 'white'}
    cursor={"default"}
  >
    <Box mr={2} h={4} w={4}><DocumentIcon/></Box>
    {data.label.length > 50 ? `${data.label.substring(0, 50)}...` : data.label}
  </Box>
);

const WorkspacePageSelector = ({onChange, pages, isLoading, selectedValue, className}) => {

  const options = pages?.map((d) => ({
    value: d.id,
    label: d.title,
  }));

  const handleChange = (option) => {
    onChange(option?.value); // Invokes the passed callback with the new value
  };

  return (
    <div className={className}>
      {isLoading ? (
        <CircularProgress size={6} isIndeterminate color='blue.500'/>
      ) : (<Select
        name="page"
        components={{Option: CustomOption}}
        onChange={handleChange}
        value={options?.find(option => option?.value === selectedValue)}
        options={options}
        placeholder="Click to select recent page"
        isSearchable={false}
      />)
      }
      
    </div>
  );
};

export default WorkspacePageSelector;
